module.exports = __webpack_public_path__ + "img/fishdom_blast.bd04853a.png";